import { GeoPoint } from '@/types/point-of-service';

/**
 * Generates a Google Maps URL that guides the user from their current location to the specified destination store.
 */
export default function getGoogleDirectionUrl(origin?: google.maps.LatLng, destination?: GeoPoint, travelmode?: string): string {
  const url = new URL('https://www.google.com/maps/dir/?api=1');

  if (origin && (origin.lat() && origin.lng())) {
    url.searchParams.set('origin', `${origin.lat()},${origin.lng()}`);
  }

  if (destination && ((destination.latitude && destination.longitude))) {
    url.searchParams.set('destination', `${destination.latitude},${destination.longitude}`);
  }

  if (travelmode) {
    url.searchParams.set('travelmode', `${travelmode}`);
  }

  return url.toString();
}
